export type ProblemDetails = {
  type?: string
  title?: string
  status?: number
  detail?: string
  instance?: string
  code?: string
  traceId?: string
  errors?: Record<string, string[]>
}

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly code?: string,
    public readonly problem?: ProblemDetails,
  ) {
    super(message)
    this.name = "ApiError"
  }

  get fieldErrors(): Record<string, string[]> | undefined {
    return this.problem?.errors
  }
}
